import React from "react";
import InputField from "../InputField";
import Dropdown from "../Dropdown";

const deviceLabel = (device) => {
  const parts = [device.deviceName || device.managedDevicePublicId];
  if (device.serialNumber) parts.push(device.serialNumber);
  if (device.primaryUserDisplayName) parts.push(device.primaryUserDisplayName);
  return parts.join(" · ");
};

/**
 * The "existing computer" part of the SCO form (PBI #303): pick the machine from Device
 * inventory when the customer has one, otherwise type the serial number (precondition #328).
 * Both are optional; the location tells Diflex where to set the workplace up.
 */
const ExistingComputerFields = ({ devices, loading, value, onChange }) => {
  const setField = (field, fieldValue) => onChange({ ...value, [field]: fieldValue });
  const labels = devices.map(deviceLabel);
  const selectedDevice = devices.find((d) => d.managedDevicePublicId === value.existingDevicePublicId);

  return (
    <div className="flex flex-col gap-4 border-l-2 border-mute-200 pl-4">
      <h3 className="font-bold">Existing computer</h3>

      {loading && <p className="text-sm text-mute-400">Loading your device inventory...</p>}

      {!loading && devices.length > 0 && (
        <Dropdown
          label="Computer (optional)"
          value={selectedDevice ? deviceLabel(selectedDevice) : ""}
          options={labels}
          onSelect={(label) => {
            const device = devices[labels.indexOf(label)];
            setField("existingDevicePublicId", device ? device.managedDevicePublicId : "");
          }}
          placeholder="Choose from your device inventory"
          searchable={labels.length > 8}
        />
      )}

      {!loading && devices.length === 0 && (
        <InputField
          label="Serial number (optional)"
          value={value.existingDeviceSerialNumber || ""}
          onChange={(e) => setField("existingDeviceSerialNumber", e.target.value)}
          placeholder="Serial number on the computer, if known"
        />
      )}

      <InputField
        label="Where is the computer today?"
        value={value.location || ""}
        onChange={(e) => setField("location", e.target.value)}
        placeholder="Office, room or the name of the current user"
      />
    </div>
  );
};

export default ExistingComputerFields;
